/**
 * Noms des compagnies aériennes, par code IATA.
 *
 * Partagé volontairement : la même table vivait en double, dans la page de
 * résultats (`vols-multi.resultats.tsx`) et en prose dans le prompt d'affinage
 * (`prompts/flight-filters-semantics.ts`). Rien ne vérifiait qu'elles restaient
 * d'accord, et le chatbot doit pouvoir nommer une compagnie qui n'est PAS dans
 * les résultats — donc absente de `ChatResultStats.availableAirlines`, la seule
 * source de noms dont il disposait.
 *
 * Repli assumé sur le code brut : la liste couvre les compagnies qu'on vend, pas
 * l'annuaire IATA.
 */
export const AIRLINE_NAMES = new Map([
    ['AF', 'Air France'],
    ['LH', 'Lufthansa'],
    ['LX', 'Swiss'],
    ['SN', 'Brussels Airlines'],
    ['SS', 'Corsair'],
    ['TX', 'Air Caraïbes'],
    ['UU', 'Air Austral'],
]);
export const airlineName = (code) => AIRLINE_NAMES.get(code) ?? code;
